export class PaginationControls {
  page = 1;
  limit = 50;
  offset =0 ;
  pageSize = 50;
  skip= 0;
  pageIndex = 0;
  count = 0;
  pageNo = 1;
  perPage = 50;
  autoHide = true;
  directionLinks = true;
  rotate = true;
  allData: any = [];
  limitalll = 50;
}

